<template>
    <div
        class="w-full flex items-center py-1"
    >
        <component :is="documentIcon" color="#ffffff" class="w-5 flex-shrink-0" />
        <div class="flex-1 flex items-center overflow-hidden">
            <div
                class="ml-4.5 flex-1 pr-4 text-body-6 pl-4 box-border flex-shrink-0 overflow-hidden text-ellipsis text-white whitespace-nowrap capitalize"
            >
                {{ document.title }}
            </div>
            <CheckedCircle color="#ffffff" class="flex-shrink-0" />
        </div>
    </div>
</template>

<script setup>
import FolderIcon from '@/components/icons/small/Documents/Folder.vue';
import FileIcon from '@/components/icons/small/Documents/FileDoc.vue';
import PDFIcon from '@/components/icons/small/Documents/FilePDF.vue';
import ImageIcon from '@/components/icons/small/Documents/FileJPG.vue';

import {computed} from "vue";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from '@/../tailwind.config.js'
import CheckedCircle from "@/components/icons/CheckedCircle.vue";

const props = defineProps({
    document: {
        type: Object,
        required: true
    },
});

const emit = defineEmits(['action']);

const icons = {
    folder: FolderIcon,
    file: FileIcon,
    pdf: PDFIcon,
    image: ImageIcon
}

const fullConfig = resolveConfig(tailwindConfig)

const documentIcon = computed(() => {
    if(props.document.mime_type === 'application/pdf') {
        return icons['pdf'];
    }

    if(['image/jpeg', 'image/png'].includes(props.document.mime_type)) {
        return icons['image'];
    }

    return icons['file'];
})

</script>